import { render, staticRenderFns } from "./Ketersediaan.vue?vue&type=template&id=1c10cb7c&scoped=true&"
import script from "./Ketersediaan.vue?vue&type=script&lang=js&"
export * from "./Ketersediaan.vue?vue&type=script&lang=js&"
import style0 from "./Ketersediaan.vue?vue&type=style&index=0&id=1c10cb7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c10cb7c",
  null
  
)

export default component.exports